import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const IsEU = makeShortcode("IsEU");
const IsUS = makeShortcode("IsUS");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <IsEU mdxType="IsEU">
      <pre><code parentName="pre" {...{
          "className": "language-Prompt"
        }}>{`
npx -y @posthog/wizard@latest --region eu

`}</code></pre>
    </IsEU>
    <IsUS mdxType="IsUS">
      <pre><code parentName="pre" {...{
          "className": "language-Prompt"
        }}>{`
npx -y @posthog/wizard@latest --region us

`}</code></pre>
    </IsUS>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      